import React, { Component } from "react";
import BlockUi from "react-block-ui";
import $ from "jquery";

import "react-block-ui/style.css";
import Logo from "../logo.png";
import "../CSS/Login.css";

class login extends Component {
  state = {
    blocking: false,
    mobile: "",
    time_remaining: 300,
    btnClass: "btn btn-primary btn-sm float-left mt-2 disabled",
    errorMessage: "",
    viewOtpForm: false,
  };
  toggleBlocking = () => {
    this.setState({ blocking: !this.state.blocking });
  };
  renderForm = () => {
    if (!this.state.viewOtpForm) {
      return (
        <div className="panel-login container-fluid">
          <div className="form-body row">
            <div className="login-form col align-self-center py-2">
              <div id="loginForm" className="w-100">
                <BlockUi tag="div" blocking={this.state.blocking}>
                  <div className="text-center">
                    <img
                      src={Logo}
                      className="Logo-Class"
                      alt="Dina Part"
                    ></img>
                  </div>
                  <p className="h1 mt-2">خوش آمدید!</p>
                  <p className="text-dark font-weight-bold text-justify">
                    جهت ورود به سامانه شماره موبایل خود را وارد نمایید.
                  </p>
                  <input
                    type="text"
                    className="form-control rounded text-center NumberValid"
                    id="uname"
                    name="uname"
                    placeholder="مثلاً 09124779146"
                    maxLength={11}
                    onKeyUp={this.handleMobile}
                  ></input>
                  <p className="small text-danger mb-0">
                    {this.state.errorMessage}
                  </p>
                  <button
                    className={this.state.btnClass}
                    onClick={() => this.otp(this.state.mobile)}
                    id="sing-in-button"
                  >
                    ادامه
                  </button>
                </BlockUi>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="panel-login container">
          <div className="form-body row">
            <div className="login-form col align-self-center py-2">
              <BlockUi tag="div" blocking={this.state.blocking}>
                <p className="h1 mt-2">کد اعتبارسنجی را وارد کنید.</p>
                <p className="text-dark font-weight-bold text-justify">
                  کد تأیید را به شماره {this.state.mobile} فرستادیم.
                </p>
                <p className="text-dark text-justify">
                  شماره موبایل اشتباه است؟{" "}
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => this.setState({ viewOtpForm: false })}
                  >
                    ویرایش
                  </button>{" "}
                </p>
                <input
                  type="text"
                  className="form-control rounded text-center NumberValid"
                  id="code"
                  name="code"
                  maxLength={4}
                  onKeyUp={this.otpVerify}
                ></input>
                <p className="small text-danger mb-0"></p>
                {this.handleSendAgain()}
              </BlockUi>
            </div>
          </div>
        </div>
      );
    }
  };
  render() {
    $(".NumberValid").on("input", function() {
      var e = "۰".charCodeAt(0);
      this.value = this.value.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = "٠".charCodeAt(0);
      this.value = this.value.replace(/[٠-٩]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      this.value = this.value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1");
    });
    return <React.Fragment>{this.renderForm()}</React.Fragment>;
  }
  handleSendAgain() {
    return (
      <p className="text-dark font-wieght-bold mt-2">
        کد تأیید را نگرفته اید؟{" "}
        <button
          className="btn btn-sm btn-success"
          onClick={() => this.otpVerifyAgain(this.state.mobile)}
        >
          ارسال مجدد
        </button>
      </p>
    );
  }

  otp = (mobile) => {
    this.toggleBlocking();
    fetch(
      `${process.env.REACT_APP_BASE_API_URL}/api/user/login-request-confirmation-code?mobile=${mobile}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 0) {
          //this.props.handleLogin(result);
          this.setState({ viewOtpForm: true, time_remaining: 60 });
        } else {
          this.props.toggleErrorMessage(result.message);
          this.props.toggleError();
        }
        this.toggleBlocking();
      })
      .catch((e) => {
        this.toggleBlocking();
        this.props.toggleErrorMessage("خطا در اتصال به سامانه");
        this.props.toggleError();
      });
  };

  otpVerify = (e) => {
    if (e.code === "this.otpVerify") return;
    const currentValue = e.target.value;
    if (currentValue.length === 4) {
      this.toggleBlocking();
      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/login-request-confirmation-code?mobile=${this.state.mobile}&verify_code=${currentValue}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 0) {
            this.props.handleLogin(result);
          } else {
            this.props.toggleErrorMessage(result.message);
            this.props.toggleError();
            this.toggleBlocking();
          }
        })
        .catch((e) => {
          this.props.toggleErrorMessage(
            "عدم امکان برقرار ارتباط با سرور، اینترنت خود را بررسی نمایید.",
          );
          this.props.toggleError();
          this.toggleBlocking();
        });
    }
  };

  otpVerifyAgain = (e) => {
    let mobile = e;
    if (mobile !== null && this.state.time_remaining === 0) {
      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/login-request-confirmation-code?mobile=${mobile}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 0) {
            this.setState({ viewOtpForm: true, time_remaining: 60 });
          } else {
            this.props.toggleErrorMessage(result.message);
            this.props.toggleError();
          }
        })
        .catch((e) => {
          this.props.toggleErrorMessage(
            "عدم امکان برقرار ارتباط با سرور، اینترنت خود را بررسی نمایید.",
          );
          this.props.toggleError();
        });
    } else {
      this.props.toggleErrorMessage(
        "کد تأیید به تازگی برای شما ارسال شده است چند دقیقه دیگر تلاش نمایید.",
      );
      this.props.toggleError();
    }
  };
  handleMobile = (e) => {
    const currentValue = e.target.value;
    this.setState({ mobile: currentValue });
    var phoneno = /^[0][9][0-9]{9}/;
    if (currentValue.match(phoneno)) {
      this.setState({ btnClass: "btn btn-sm btn-primary mt-2 float-left" });
      this.setState({ errorMessage: "" });
    } else {
      this.setState({ btnClass: "btn btn-sm btn-primary float-left disabled" });
      const errorMessage =
        this.state.mobile.length === 0
          ? "شماره موبایل خود را وارد نمایید."
          : "شماره موبایل وارد شده اشتباه است.";
      this.setState({ errorMessage: errorMessage });
    }
  };
}

export default login;
